import { ApiService, ApiZones } from './api.service';
import {
  Customer,
  CustomerList,
  CustomerModuleKey,
  CustomerModules,
} from '../models/customer';
import { Deserialize, IJsonObject, Serialize } from 'dcerialize';
import { Observable, forkJoin } from 'rxjs';
import { getStorageObject, setStorageObject } from '../utils/storage-manager';
import { map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  get path(): string {
    return this.apiService.getApiUrl() + 'customers';
  }

  /**
   * List all customers from all regions
   * @returns List of customers
   */
  listCustomers(): Observable<CustomerList> {
    const customerRequests: Observable<CustomerList>[] = []

    this.apiService.getValidZones().forEach(zone => {
      customerRequests.push(this.listCustomersByZone(zone))
    })

    const allZonesCustomers = new CustomerList()

    return forkJoin(customerRequests).pipe(map((customers) => {

      // Here all customers data from different regions is merged into one object
      customers.forEach((customer) => {
        allZonesCustomers.items.push(...customer.items)
        allZonesCustomers.total += customer.total
      })

      return allZonesCustomers
    }))

  }

  /**
   * List all customers from a specific region
   * @param zone - The region to list customers from ex: EU, US
   * @returns List of customers
   */
  listCustomersByZone(zone: ApiZones = ApiZones.EU): Observable<CustomerList> {
    return this.http.get<IJsonObject>(this.apiService.securityApiUrl(zone) + '/customers').pipe(
      map((response) => {
        return Deserialize(response, () => CustomerList);
      })
    );
  }

  getCustomer(subdomain: string): Observable<Customer> {
    return this.http.get<IJsonObject>(`${this.path}/${subdomain}`).pipe(
      map((response) => {
        return Deserialize(response, () => Customer);
      })
    );
  }

  updateModuleByKey(module: CustomerModules, moduleName: CustomerModuleKey): Observable<IJsonObject> {
    return this.http.patch<IJsonObject>(`${this.path}/modules/${moduleName}`,
      Serialize(module, () => CustomerModules)).pipe(
      tap(() => {
        const customer: Customer = getStorageObject('vertical');
        if(!customer || !customer.modules || !customer.modules[moduleName]) {
          return;
        }
        customer.modules[moduleName] = module.modules[moduleName];
        setStorageObject('vertical', customer);
      })
    );
  }

  getCustomerModules(subdomain: string): Observable<CustomerModules> {
    return this.http.get<IJsonObject>(`${this.path}/${subdomain}/modules`).pipe(
      map((jsonRequest) => {
        return Deserialize(jsonRequest, () => CustomerModules);
      })
    )
  }
}
